import { Component } from '@angular/core';
import { ActionSheetController, ModalController, NavParams, ViewController } from 'ionic-angular';

import { WorkoutModel, WorkoutExerciseModel } from '../../../models/models';
import { ConfigurationProvider, WorkoutProvider } from '../../../providers/providers';
import { DashboardWorkoutExercisesPage } from './dashboard-workout-exercises';
import { DashboardWorkoutSetPage } from './dashboard-workout-set';

@Component({
  selector: 'page-dashboard-workout',
  templateUrl: 'dashboard-workout.html',
})
export class DashboardWorkoutPage {
  workout: WorkoutModel;
  exercisesDeleted: number[] = [];

  constructor(
    private actionsheetCtrl: ActionSheetController,
    private config: ConfigurationProvider,
    private modalCtrl: ModalController,
    private params: NavParams,
    private viewCtrl: ViewController,
    private workoutProvider: WorkoutProvider) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  dismissView(item = null) {
    this.viewCtrl.dismiss({
      saved: true,
      name: item ? item.Name : null
    });
  }

  doOpenLastWorkout() {
    let modal = this.modalCtrl.create(DashboardWorkoutExercisesPage, { 
      workout: this.workout.LastWorkout
    });
    modal.present();
  }

  doOpenMenu(exercise: WorkoutExerciseModel, exerciseIndex) {
    let showModal = (newExercise) => {
      let modal = this.modalCtrl.create(DashboardWorkoutSetPage, { 
        "exercise": newExercise,
        "workout": this.workout
      });
      modal.onDidDismiss(() => {
        this.setMaxSets();
      });
      modal.present();
    };
    
    let buttons = [
      {
        text: 'Edit',
        role: '',
        icon: 'create',
        handler: () => {
          showModal(exercise);
        }
      },
      {
        text: 'Add Exercise',
        role: '',
        icon: 'arrow-down',
        handler: () => {
          let newExercise = this.workoutProvider.AddExercise(this.workout, exerciseIndex + 1);
          showModal(newExercise);
        }
      },
      {
        text: 'Copy Exercise',
        role: '',
        icon: 'copy',
        handler: () => {
          let newExercise = this.workoutProvider.AddExercise(this.workout, exerciseIndex + 1, Object.assign({}, exercise));
          showModal(newExercise);
        }
      }
    ];

    if (this.workout.Exercises.length > 1) {
      buttons.push({
        text: 'Remove',
        role: 'destructive',
        icon: 'trash',
        handler: () => {
          if (exercise._id) {
            this.exercisesDeleted.push(exercise._id);
          }
          this.workoutProvider.RemoveExercise(this.workout, exercise);
        }
      });
    }

    // action sheet
    let actionSheet = this.actionsheetCtrl.create({
      title: exercise.Name,
      subTitle: 'Exercise',
      buttons: buttons
    });
    actionSheet.present();
  }

  doSave() {
    if (this.formIsValid()) {
      this.config.showLoading('Saving...');

      // delete items, if any
      if (this.exercisesDeleted.length > 0) {
        this.workoutProvider.DeleteExercises(this.exercisesDeleted);
      }

      // save
      this.workoutProvider.Save(this.workout).then(res => {
        this.config.dismissLoading();
        this.dismissView(this.workout);
      });
    }
  }

  formIsValid() {
    if (!this.workout.Name) {
      this.config.showAlert('Error', 'Enter a Name.');
      return false;
    }
    if (!this.workout.Time) {
      this.config.showAlert('Error', 'Enter a time.');
      return false;
    }
    if (this.workout.Exercises.some(x => !x.ExerciseId)) {
      this.config.showAlert('Error', 'One or more exercises were not selected.');
      return false;
    }

    return true;
  }

  ionViewWillLoad() {
    this.workout = this.params.get('workout');
  }

  setMaxSets() {
    this.workout.MaxSets = Array(Math.max.apply(Math, this.workout.Exercises.map(x => x.Sets.length)));
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/exercise/dashboard-workout.ts